// extracted by mini-css-extract-plugin
module.exports = {"no-social-accounts":"social-share_no-social-accounts__3re2U","social-share-page-container":"social-share_social-share-page-container__2Pd4o"};